import React from "react";
import styled from "styled-components";
import { narrowScreenMediaQuery, white } from "../constants/styles";
import { unmodule } from "../util";

export const ModalContext = React.createContext([]);

const UnnamedComponent = (props) => {
  const [shownModal, setShownModal] = React.useState();
  const [animating, setAnimating] = React.useState(false);

  const handleEscapeClick = React.useCallback((evt) => {
    if (evt.key === "Escape") {
      closeModal();
    }
  }, []);
  const disableScroll = React.useCallback(() => {
    document.body.style.overflow = "hidden";
  }, []);
  const enableScroll = React.useCallback(() => {
    document.body.style.overflow = "unset";
  }, []);
  const openModal = React.useCallback((args) => {
    setShownModal(args);
    disableScroll();
    document.addEventListener("keydown", handleEscapeClick);
  }, []);
  const closeModal = React.useCallback(() => {
    setShownModal();
    enableScroll();
    document.removeEventListener("keydown", handleEscapeClick);
  }, []);

  const stopPropagation = React.useCallback((e) => {
    e.stopPropagation();
  }, []);
  const handleClickOutsideModalEffect = React.useCallback((e) => {
    if (animating) return;
    setAnimating(true);
    const el = e.target.querySelector("div");
    // const width = el.clientWidth;
    // const height = el.clientHeight;
    const { paddingLeft, paddingRight, paddingTop, paddingBottom } =
      window.getComputedStyle(el);
    // const actualWidth =
    // width - parseFloat(paddingLeft) - parseFloat(paddingRight);
    // const actualHeight =
    // height - parseFloat(paddingTop) - parseFloat(paddingBottom);

    // el.style.width = `${actualWidth * 1.01}px`;
    // el.style.height = `${actualHeight * 1.01}px`;

    el.style.paddingLeft = `${parseFloat(paddingLeft) * 1.2}px`;
    el.style.paddingRight = `${parseFloat(paddingRight) * 1.2}px`;
    el.style.paddingTop = `${parseFloat(paddingTop) * 1.2}px`;
    el.style.paddingBottom = `${parseFloat(paddingBottom) * 1.2}px`;

    setTimeout(() => {
      // el.style.width = `${actualWidth}px`;
      // el.style.height = `${actualHeight}px`;

      el.style.paddingLeft = `${paddingLeft}`;
      el.style.paddingRight = `${paddingRight}`;
      el.style.paddingTop = `${paddingTop}`;
      el.style.paddingBottom = `${paddingBottom}`;
      setAnimating(false);
    }, 100);
  }, []);

  const contextValue = React.useMemo(
    () => ({
      openModal,
      closeModal,
    }),
    [openModal, closeModal],
  );
  return (
    <ModalContext value={contextValue}>
      {props.children}
      {shownModal && (
        <ModalContainer onClick={handleClickOutsideModalEffect}>
          <ModalDialog onClick={stopPropagation}>
            <ModalHeader>
              <Title>{shownModal.title}</Title>
              <CloseImg
                src={unmodule(require("../images/icons/close.svg"))}
                tabIndex="0"
                onClick={closeModal}
              />
            </ModalHeader>
            <InnerSeparator />
            <ModalBody>{shownModal.body}</ModalBody>
            <InnerSeparator />
            <ModalFooter></ModalFooter>
          </ModalDialog>
        </ModalContainer>
      )}
    </ModalContext>
  );
};

export default UnnamedComponent;

const InnerSeparator = styled.div`
  background-color: #383939;
  height: 1px;
  margin-left: -20px;
  width: calc(100% + 40px);
  margin-top: 10px;
  margin-bottom: 10px;
`;

const ModalContainer = styled.div`
  background-color: #000000c7;
  color: ${white};
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 5;
`;

const ModalDialog = styled.div`
  background-color: #242424;
  border-radius: 5px;
  left: 50%;
  min-width: 700px;
  padding: 10px 20px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -70%);
  transition: all 0.1s;

  @media ${narrowScreenMediaQuery} {
    min-width: 300px;
    transform: translate(-50%, -50%);
  }
`;

const ModalHeader = styled.div`
  align-items: start;
  display: flex;
  gap: 20px;
  justify-content: space-between;
  padding: 12px 0;
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: bold;
`;

const ModalBody = styled.div`
  & > table {
    background-color: #2e2f30;
    width: 100%;
    border: 1px solid white;

    & th {
      padding: 15px;
      border-bottom: 1px solid #757575;

      &:not(:first-child) {
        border-left: 1px solid #757575;
      }
    }

    & td {
      padding: 15px;

      &:first-child {
        white-space: nowrap;
      }

      &:not(:first-child) {
        border-left: 1px solid #757575;
      }
    }

    & tr:not(:last-child) > td {
      border-bottom: 1px solid #595959;
    }
  }
`;

const ModalFooter = styled.div`
'`;

const CloseImg = styled.img`
  cursor: pointer;

  &:hover,
  &:active,
  &:focus {
    transform: translate(1px, 1px);
  }
`;
